import * as React from "react";
import { useHistory } from "react-router";
import { useRecoilValue } from "recoil";

import { DiagnosisCompatibilityAgentsStepChips } from "@/components/diagnosis/DiagnosisCompatibilityAgentsStepChips";
import { usePlannerIntroductionEntrance } from "@/hooks/usePlannerIntroductionEntrance";
import { PlannerIntroductionLayout } from "@/layouts/PlannerIntroductionLayout";
import { UserState } from "@/view_models/atoms";

import { DiagnosisCompatibilityAgentsIntro } from "./components/DiagnosisCompatibilityAgentsIntro";
import {
  buildAnnualIncomeLabel,
  buildAreaLabel,
  buildFinancialAssetLabel,
  buildPropertyTypesLabel,
  buildStageLabel,
} from "./utils/conditionLabels";

// 「マッチングに使用する条件」カードの説明用サンプル値（中庸の例示値固定。実データではない）。
const SAMPLE_SCORES = {
  property_type: 3,
  annual_income: 4,
  financial_asset: 3,
  investment_stage: 4,
  area: 3,
};

export const DiagnosisCompatibilityAgentsIntroPage: React.FC = () => {
  const history = useHistory();
  const user = useRecoilValue(UserState);
  const animate = usePlannerIntroductionEntrance("intro");

  const conditionItems = [
    { label: "物件種別", value: buildPropertyTypesLabel(user) },
    { label: "エリア", value: buildAreaLabel(user) },
    { label: "年収", value: buildAnnualIncomeLabel(user) },
    { label: "資産", value: buildFinancialAssetLabel(user) },
    { label: "ステージ", value: buildStageLabel(user) },
  ];

  return (
    <PlannerIntroductionLayout phaseTags={<DiagnosisCompatibilityAgentsStepChips />}>
      <DiagnosisCompatibilityAgentsIntro
        animate={animate}
        radarScores={SAMPLE_SCORES}
        conditionItems={conditionItems}
        onClickViewCompatibleAgents={() => history.push("/diagnosis_compatibility_agents/certified")}
      />
    </PlannerIntroductionLayout>
  );
};
